import { createBrowserHistory, createMemoryHistory } from "history";
import { store } from "../store/custom-store";
import { clearAuth } from "../actions/actions-auth";
import { emitter } from "./emitter";
import { alert } from "../utils/alert";

export const browserHistory = createBrowserHistory();
export const memoryHistory = createMemoryHistory();

// login time out
let timeout = null;
export const loginTimeOut = async (data) => {
  try {
    if (data.json) {
      const resultJson = await data.json();
      if (resultJson && resultJson.data && resultJson.data.message) {
        if (timeout) {
          clearTimeout(timeout);
          timeout = null;
        }
        timeout = setTimeout(() => {
          alert("error", resultJson.data.message);
        }, 500);
      }
    }

    store.dispatch(clearAuth());
    emitter.emit("FETCH_LOADING", false);
    browserHistory.push("/login");
  } catch (error) {
    store.dispatch(clearAuth());
    emitter.emit("FETCH_LOADING", false);
    browserHistory.push("/login");
  }
};
